import React from 'react';
import { tokenContext } from './componentes/TokenContext';
import { AppRouter } from './routers/AppRouter';
import { useConsolekiller } from './hooks/useConsolekiller';
import "animate.css";


export const Topups = ( {token1, pay1} ) => {

    useConsolekiller();
   
    return (
        <tokenContext.Provider value={{token:token1, pay:pay1}}>
            <AppRouter/>
        </tokenContext.Provider>
        
    )
}
